import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
// import ReactDOM from 'react-dom';
import "../../Common/Lib/react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from '../../Common/Lib/react-responsive-carousel';
import {home_page } from "../../data"
import "./LandingPage.css";
import {HashLink as Link} from "react-router-hash-link";
import {BrowserRouter as Router} from "react-router-dom";




function App() {
    return <RCarousel {...CarouselData} />;
  }
  
  export default App;

function RCarousel(props) {
    const {
        spanText1,
        spanText2,
        spanText3,
        spanText11,
        spanText31,
        spanText12,
        spanText32,
        spanText13,
        spanText33,
    } = props;
    
        return (
            <Carousel interval={4000} transitionTime={2000} autoPlay={true} infiniteLoop={true} showArrows={false} showStatus={false} showThumbs={false} animationHandler="fade" swipeable={true}>
                <div>
                  <img src={home_page.HomePageCarousel1} alt="First slide"  /> 
                  <div className="lpd-frame-16">
                    <div className="lpd-text-1 lpd-valign-text-middle animate-enter1">
                        <span>
                          <span className="lpd-span2 ">{spanText1}</span>
                        </span>
                    </div>
                      <span className="lpd-span0 lpd-overpass-semi-bold-white-32px">{spanText3}</span>
                      <Link to="#whyWebuild">
                        <div className="lpt-x26013033 lpt-component lpt-component-wrapper not-ready">
                          <div className="lpt-master-button-Y0gomr">
                            <div className="lpt-button-i2601303351-0VL8Sj lpt-valign-text-middle">READ MORE</div>
                          </div>
                        </div>                      
                      </Link>
                  </div>
                </div>
                <div>
                  <img src={home_page.HomePageCarousel2} alt="First slide"  /> 
                  <div className="lpd-frame-16">
                    <div className="lpd-text-1 lpd-valign-text-middle animate-enter1">
                        <span>
                          <span className="lpd-span2 ">{spanText11}</span>
                        </span>
                    </div>
                      <span className="lpd-span0 lpd-overpass-semi-bold-white-32px">{spanText31}</span>
                      <Link to="#estimate">
                        <div className="lpt-x26013033 lpt-component lpt-component-wrapper not-ready">
                          <div className="lpt-master-button-Y0gomr">
                            <div className="lpt-button-i2601303351-0VL8Sj lpt-valign-text-middle">GET A QUOTE</div>
                          </div>
                        </div>                      
                      </Link>
                  </div>                   
                </div>
                <div>
                  <img src={home_page.HomePageCarousel3} alt="First slide"  /> 
                  <div className="lpd-frame-16">
                    <div className="lpd-text-1 lpd-valign-text-middle animate-enter1">
                        <span>
                          <span className="lpd-span2 ">{spanText12}</span>
                        </span>
                    </div>
                    <span className="lpd-span0 lpd-overpass-semi-bold-white-32px">{spanText32}</span>
                      <Router forceRefresh={true}>
                        <Link to="/packagedetails/1/1">
                          <div className="lpt-x26013033 lpt-component lpt-component-wrapper not-ready">
                            <div className="lpt-master-button-Y0gomr">
                              <div className="lpt-button-i2601303351-0VL8Sj lpt-valign-text-middle">READ MORE</div>
                            </div>
                          </div>                      
                        </Link>
                      </Router>
                  </div>                   
                </div>
                <div>
                  <img src={home_page.HomePageCarousel4} alt="First slide"  /> 
                  <div className="lpd-frame-16">
                    <div className="lpd-text-1 lpd-valign-text-middle animate-enter1">
                        <span>
                          <span className="lpd-span2 ">{spanText13}</span>
                        </span>
                    </div>
                    <span className="lpd-span0 lpd-overpass-semi-bold-white-32px">{spanText33}</span>
                      <Link to="/project">
                        <div className="lpt-x26013033 lpt-component lpt-component-wrapper not-ready">
                          <div className="lpt-master-button-Y0gomr">
                            <div className="lpt-button-i2601303351-0VL8Sj lpt-valign-text-middle">VIEW ALL</div>
                          </div>
                        </div>                      
                      </Link>
                  </div>                  
                </div>
            </Carousel>
        );
    
}

// function GetAQuoteButton2(props) {
//     const { children } = props;
  
//     useEffect(() => {
//       loadTimelineData(x26013033TimelineData);
//     }, []);
  
//     return (
//       <div className="lpt-x26013033 lpt-component lpt-component-wrapper not-ready">
//         <div className="lpt-master-button-Y0gomr">
//           <div className="lpt-button-i2601303351-0VL8Sj lpt-valign-text-middle">{children}</div>
//         </div>
//       </div>
//     );
//   }
  
  const x26013033TimelineData = [
    {
      initial_state_name: "Property-1=Primary",
      root_element: ".x26013033",
      states_flow: {
        "Property-1=Primary": {
          listeners: [],
          overrides: {},
        },
        "Property-1=Secondary": {
          listeners: [],
          overrides: {},
        },
        "Property-1=Tertiary": {
          listeners: [],
          overrides: {},
        },
      },
    },
  ];

const getAQuoteButton2Data = {
    children: "GET A QUOTE",
};

const CarouselData = {
  spanText1: " Why WeBuildd?",
  spanText2: <> <br /></>,
  spanText3: " Build it better in concrete with WeBuildd ",
  spanText11: " How does the calculator help?",
  spanText31: " Choose the Right Path with our Calculator ",
  spanText12: " Choose from various packages to suit your budget.",
  spanText32: " Choose a plan that’s right for you! ",
  spanText13: " Projects",
  spanText33: " Check out the dream spaces we have built",

    // text42: <>At Webuilld we offer you a completely<br />“Unified Conception to Construction” value proposition.  <br />No more dealing with a dozen sub-contractors or labour hassles when constructing your home or commercial building</>,
    getAQuoteButton2Props: getAQuoteButton2Data,
};